import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const visitorPinSlice = createAsyncThunk(
  "visitorPinSlice",
  async (id) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");
      const response = await AxiosInstance.get(
        `${API_KEY}/api/amenity/access-details/society/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          "Content-Type": "application/json",
        }
      );
      return response;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);

const initialState = {
  isLoading: false,
  visitorPinSliceData: null,
  isError: false,
  errorMessage: "",
};

const visitorPinSliceSlice = createSlice({
  name: "visitorPinSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(visitorPinSlice.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(visitorPinSlice.fulfilled, (state, action) => {
      state.isLoading = false;
      state.visitorPinSliceData = action.payload;
    });
    builder.addCase(visitorPinSlice.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default visitorPinSliceSlice.reducer;
